module.exports = __webpack_public_path__ + "33f225b8f5f7d6b34a0926f58f96c1e9.ttf";